import validate from "validate.js";
import { LockDeviceType } from "./BikeDetailsModel";

const genericRequiredMessage = "Pole jest wymagane";

export const bikeDetailsFormValidation = (values) => {
  const constraints = {
    bikeNumber: {
      presence: { message: genericRequiredMessage },
    },
    lockImei: function (value, attributes) {
      if (attributes.lockType === LockDeviceType.flotaOnline.value) {
        return {
          presence: { allowEmpty: false, message: genericRequiredMessage },
          format: { pattern: /^(?!00000000-0000-0000-0000-000000000000$)[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
            message: 'Podaj UUID z pola Id API Flota-Online' },
        };
      }
      if (attributes.lockType === LockDeviceType.notione.value) {
        return {};
      }
      return {
        presence: { message: genericRequiredMessage },
      };
    },
    lockPhoneNumber: function (value, attributes) {
      if ([LockDeviceType.notione.value, LockDeviceType.flotaOnline.value].includes(attributes.lockType)) {
        return {};
      }
      return {
        presence: { message: genericRequiredMessage },
        format: {
          pattern: /^\d{11}$/,
          message:
            "Numer telefonu musi składać się z 11-tu cyfr (MSIDN) na przykład 48333444555.",
        },
      };
    },
    lockSimSerialNumber: function (value, attributes) {
      if ([LockDeviceType.notione.value, LockDeviceType.flotaOnline.value].includes(attributes.lockType)) {
        return {};
      }
      return {
        presence: { message: genericRequiredMessage },
      };
    },
    lockType: {
      presence: { message: genericRequiredMessage },
    },
  };

  return validate(values, constraints, { fullMessages: false });
};
